var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1701 17.415L15.4951 10.74C15.4181 10.6635 15.3268 10.6029 15.2265 10.5617C15.1261 10.5205 15.0186 10.4996 14.9101 10.5C14.8026 10.4989 14.696 10.5196 14.5967 10.5608C14.4975 10.6021 14.4076 10.663 14.3326 10.74L13.8376 11.2275C13.6859 11.383 13.601 11.5915 13.601 11.8087C13.601 12.0259 13.6859 12.2345 13.8376 12.39L19.4476 18L13.8301 23.61C13.6794 23.7643 13.5959 23.9719 13.5976 24.1875C13.5971 24.4051 13.6803 24.6146 13.8301 24.7725L14.3251 25.26C14.4796 25.4134 14.6885 25.4995 14.9063 25.4995C15.1241 25.4995 15.333 25.4134 15.4876 25.26L22.1701 18.5775C22.2479 18.5035 22.3089 18.4136 22.3491 18.314C22.3892 18.2144 22.4074 18.1073 22.4026 18C22.4052 17.8918 22.386 17.7843 22.3461 17.6837C22.3061 17.5832 22.2462 17.4918 22.1701 17.415Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMenu);
export default __webpack_public_path__ + "static/media/OpenMenu.0221e761.svg";
export { ForwardRef as ReactComponent };